import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { ExpandableContentContent, ExpandableContentWrapper } from "./ExpandableContent.styles";
var ANIMATION_DURATION = 300;

var setNodeHeightToZero = function setNodeHeightToZero(node) {
  node.style.height = '0px';
  node.style.opacity = '0';
};

var setNodeHeightBasedOnFirstChild = function setNodeHeightBasedOnFirstChild(node) {
  var wrapper = node.firstElementChild;
  node.style.height = "".concat(wrapper.scrollHeight, "px");
  node.style.opacity = '1';
};

var resetNodeHeight = function resetNodeHeight(node) {
  node.style.height = null;
  node.style.opacity = null;
};

export var ExpandableContent = function ExpandableContent(_ref) {
  var animationDuration = _ref.animationDuration,
      expanded = _ref.expanded,
      children = _ref.children;
  var duration = animationDuration || ANIMATION_DURATION;
  return React.createElement(CSSTransition, {
    mountOnEnter: true,
    unmountOnExit: true,
    onEnter: setNodeHeightToZero,
    onEntering: setNodeHeightBasedOnFirstChild,
    onEntered: resetNodeHeight,
    onExit: setNodeHeightBasedOnFirstChild,
    onExiting: setNodeHeightToZero,
    onExited: resetNodeHeight,
    classNames: "details",
    timeout: duration,
    in: expanded
  }, React.createElement(ExpandableContentWrapper, {
    animationDuration: duration
  }, React.createElement(ExpandableContentContent, null, children)));
};